<template>
<el-row class="container-card el-row">
  <TrackOverview />
</el-row>
</template>

<script>
import TrackOverview from '@/modules/label/tracks/components/TableOverview'

export default {
  components: {
    TrackOverview
  }
}
</script>
